import { render, staticRenderFns } from "./ViewChicksByCorral.vue?vue&type=template&id=3ddc54ce&scoped=true"
import script from "./ViewChicksByCorral.vue?vue&type=script&lang=js"
export * from "./ViewChicksByCorral.vue?vue&type=script&lang=js"
import style0 from "./ViewChicksByCorral.vue?vue&type=style&index=0&id=3ddc54ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc54ce",
  null
  
)

export default component.exports